export default {
  brand: 'USFans Spreadsheet',
  nav_home: 'Inicio',
  nav_guide: 'Guía',
  nav_shopping_guide: 'Guía de compra',
  nav_categories: 'Categorías',
  nav_article: 'Artículos',
  nav_faq: 'FAQ',
  nav_safety: 'Seguridad',

  hero_eyebrow: 'CENTRO DE RECURSOS DE USFANS SPREADSHEET',
  hero_h1: 'USFans Spreadsheet — encuentra mejores listas, guías y recursos',
  hero_desc:
    'Explora recursos organizados de USFans spreadsheet, guías de compra, información de vendedores, consejos de control de calidad, detalles de envío, reseñas y comparaciones prácticas — todo en un solo lugar.',
  hero_cta_main: 'USFans Spreadsheet',
  hero_cta_buy: 'Comprar ahora',
  hero_cta_guide: 'Leer la guía',
  hero_trust: 'Recurso independiente · Actualizado con regularidad · Multilingüe · Enfocado en la seguridad',

  categories_title: 'Explora las categorías de productos',
  categories_subtitle: 'Salta directo a la categoría que buscas en la web principal.',
  categories_dropdown_label: 'Elige una categoría',
  categories_all: 'Todas las categorías',

  about_eyebrow: '¿QUÉ ES USFANS SPREADSHEET?',
  about_title: 'Todo lo que necesitas sobre USFans Spreadsheet',
  about_desc:
    'En lugar de buscar entre información dispersa, explora un centro de recursos estructurado de USFans Spreadsheet con listas útiles, guías de compra, investigación de vendedores, control de calidad, envío, información de almacén, reseñas, cupones y guías de seguridad.',
  about_cta: 'Explora USFans Spreadsheet',

  resources_eyebrow: 'RECURSOS POPULARES',
  resources_title: 'Recursos populares de USFans',
  resources_subtitle: 'Profundiza con nuestras guías y artículos originales y útiles.',
  article_card_title: 'USFans Spreadsheet: guía completa',
  article_card_desc:
    'Aprende qué es una hoja de cálculo de USFans, cómo usarla y cómo comprar de forma más inteligente con listas y recursos organizados.',
  read_more: 'Leer el artículo',
  read_guide: 'Leer la guía',

  pillars_eyebrow: 'GUÍAS PILAR DE USFANS',
  pillars_title: 'Guías de USFans en profundidad',
  pillars_subtitle:
    'Explora nuestros artículos pilar originales sobre reseñas, envío, cupones, almacén, seguridad y más.',

  safety_title: '¿USFans es legítimo y seguro?',
  safety_desc:
    'Antes de usar cualquier plataforma de compras, verifica la dirección web, protege la información de tu cuenta, investiga los métodos de pago y mantente atento ante ofertas sospechosas. Nuestros recursos de seguridad explican formas prácticas de reducir los riesgos online más comunes.',
  safety_cta: 'Visita el Centro de seguridad',

  faq_title: 'Preguntas frecuentes',
  faq_subtitle: 'Respuestas rápidas a las preguntas más comunes sobre USFans Spreadsheet.',
  faq_1_q: '¿Qué es USFans Spreadsheet?',
  faq_1_a:
    'USFans Spreadsheet es un recurso organizado que reúne enlaces de productos, categorías y detalles de compra en un solo lugar, para que navegues y compares artículos con más eficacia.',
  faq_2_q: '¿Dónde encuentro los enlaces de USFans spreadsheet?',
  faq_2_a:
    'Puedes explorar las categorías de productos directamente en esta página o continuar a la web principal para ver la selección completa de enlaces y productos.',
  faq_3_q: '¿La hoja de cálculo de USFans se actualiza con regularidad?',
  faq_3_a:
    'Sí, se actualiza con frecuencia para reflejar las categorías y enlaces actuales. Confirma siempre la información más reciente en la web principal antes de pedir.',

  final_title: '¿Listo para explorar los recursos de USFans Spreadsheet?',
  final_desc:
    'Empieza con la guía completa de USFans Spreadsheet, explora recursos prácticos y compara información importante antes de continuar a la web principal.',
  final_cta_main: 'Explora USFans Spreadsheet',
  final_cta_buy: 'Visitar la web principal',

  footer_tagline:
    'Un centro de recursos multilingüe e independiente de USFans Spreadsheet — guías originales, listas e información de seguridad.',
  footer_explore: 'Explorar',
  footer_resources: 'Recursos',
  footer_languages: 'Idiomas',
  footer_disclaimer:
    'USFansSheet.casa es un recurso informativo independiente y no está afiliado ni respaldado oficialmente por USFans, salvo que se indique expresamente.',

  back_home: 'Volver al inicio',
  related_article: 'Recursos relacionados',
  visit_main_site: 'Visitar la web principal',
  article_not_found: 'Artículo no encontrado',

  category_shoes: 'Zapatos',
  category_hoodies: 'Sudaderas/Jerséis',
  category_tshirts: 'Camisetas',
  category_jackets: 'Chaquetas',
  category_pants: 'Pantalones/Pantalones cortos',
  category_headwear: 'Gorros/Sombreros',
  category_sets: 'Conjuntos',
  category_underwear: 'Ropa interior/Calzoncillos',
  category_jersey: 'Camiseta deportiva',
  category_accessories: 'Accesorios',
  category_bags: 'Bolsos',
  category_belts: 'Cinturones',
  category_perfumes: 'Perfumes',
  category_other: 'Otras cosas',
};